import { Play } from "@bloomberg/media-ui-iconography";

import * as Eyebrow from "@components/eyebrow/index";
import * as Image from "@components/image/index";

import { BigCardProps } from "./types";

import styles from "./styles.module.css";

export function StyledText(
  props: Pick<BigCardProps, "url" | "text" | "tracker">,
) {
  return (
    <a
      href={props.url}
      className={styles.text}
      data-role="linked-text"
      aria-label={props.text}
      ref={props.tracker?.registerTracking}
    >
      {props.text}
    </a>
  );
}

export const StyledPlayIcon = () => (
  <div className={styles.playIcon}>
    <Play aria-label="Play Icon" />
  </div>
);

export function StyledImage(
  props: Pick<BigCardProps, "image" | "playIcon" | "url" | "text" | "tracker">,
) {
  return (
    <a
      className={styles.image}
      data-skeleton-selector
      href={props.url}
      tabIndex={-1}
      data-role="linked-image"
      aria-label={`[image]${props.text}`}
      ref={props.tracker?.registerTracking}
    >
      <Image.Component {...props.image} />
      {props.playIcon && <StyledPlayIcon />}
    </a>
  );
}

export const StyledEyebrow = (props: Pick<BigCardProps, "eyebrow">) => (
  <div className={styles.eyebrow}>
    <Eyebrow.Component {...props.eyebrow} />
  </div>
);
